import { render } from "./ExportOrders.vue?vue&type=template&id=1176ef63&scoped=true"
import script from "./ExportOrders.vue?vue&type=script&lang=js"
export * from "./ExportOrders.vue?vue&type=script&lang=js"

import "./ExportOrders.vue?vue&type=style&index=0&id=1176ef63&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1176ef63"],['__file',"src/components/orders/ExportOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1176ef63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1176ef63', __exports__)) {
    console.log('reload')
    api.reload('1176ef63', __exports__)
  }
  
  module.hot.accept("./ExportOrders.vue?vue&type=template&id=1176ef63&scoped=true", () => {
    console.log('re-render')
    api.rerender('1176ef63', render)
  })

}


export default __exports__